import { getOrderDoc } from '../../services/api/order.api';
import { transformOrderDocDetail } from '../../transforms/order';
import { transformError } from '../../transforms/error';
import { GET_ORDER_DOC_REQUEST, GET_ORDER_DOC_SUCCESS, GET_ORDER_DOC_FAILURE } from '../types';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformOrderDocDetail({}),
	},

	mutations: {
		[GET_ORDER_DOC_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_ORDER_DOC_SUCCESS](state, data) {
			state.isLoading = false;
			state.data = transformOrderDocDetail(data);
		},
		[GET_ORDER_DOC_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getOrderDoc({ commit }, { id, params }) {
			try {
				commit(GET_ORDER_DOC_REQUEST);
				const { data } = await getOrderDoc(id, params);
				commit(GET_ORDER_DOC_SUCCESS, data);
			} catch (error) {
				commit(GET_ORDER_DOC_FAILURE, error);
			}
		},
	},
};